import { render, staticRenderFns } from "./VideoHome.vue?vue&type=template&id=b9384666&scoped=true&"
import script from "./VideoHome.vue?vue&type=script&lang=ts&"
export * from "./VideoHome.vue?vue&type=script&lang=ts&"
import style0 from "./VideoHome.vue?vue&type=style&index=0&id=b9384666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9384666",
  null
  
)

export default component.exports